import * as Redux from 'redux'
import * as App from '../../app'
import * as DateSelector from '../../components/date-selector'
import * as Actions from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

const emptyViewState: Types.EngagementSummaryViewState = {
  isLoading: false,
  selectedCommunity: {description: '', key: '', value: ''},
  selectedTime: Constants.FOUR_WEEKS,
  sort: [],
  type: '',
}

type AllActions = Redux.Action &
                  Request.SuccessAction &
                  DateSelector.DatedInformationAction &
                  Sortable.SortAction &
                  DateSelector.SelectDateRangeAction &
                  IsActive.FilterActionObject &
                  Actions.Actions<{value: string}>

export const summaryTypeReducer =
  (state: Types.EngagementSummaryViewState, action: AllActions) => {
  switch (action.type) {
    case Request.requestConstant(Constants.FETCH_ENGAGEMENT_SUMMARY):
      if (action.options.url.includes('aggregation=domain')) {
        return {
          ...state,
          type: Constants.DOMAIN,
        }
      } else {
        return {
          ...state,
          type: Constants.GENERAL,
        }
      }
    case Constants.DEFINE_COMMUNITY:
      return {
        ...state,
        selectedCommunity: {description: action.value,
                            key: action.value ,
                            value: action.value},
      }
    default:
      return state
  }
}

const filtersReducer = (state: Types.EngagementSummaryViewState, action: AllActions) => {
  switch (action.type) {
    case IsActive.filterStatusConstant(Constants.CHANGE_COMMUNITY):
      return {
        ...state,
        selectedCommunity: action.filter,
      }
    case IsActive.filterStatusConstant(Constants.CHANGE_TIME_SPAN):
      return {
        ...state,
        selectedTime: action.filter,
      }
    default:
      return state
  }
}

export const viewReducer = (sourceReducer: any) =>
  (state: Types.EngagementSummaryViewState = emptyViewState, action: AllActions) => {
  const sourceState = sourceReducer(state, action)
  switch (action.type) {
    case App.URL_PARSED:
      return {
        ...state,
      }
    default:
      return sourceState
  }
}

const normalizeTypes: Sortable.TypeNormalizer<Types.EngagementSummary> =
  (payload: Sortable.SortableData<Types.EngagementSummary>):
  Sortable.SortableData<Types.EngagementSummary> => {
  return payload.map((lp: Types.EngagementSummary) => ({
    ...lp,
  }))
}

const reducerEvent: Sortable.ReducerEvent<Types.EngagementSummary> = {
  defaultSort: {field: 'identifier', dir: 'asc'},
  normalizer: normalizeTypes,
  requestEvent: Constants.FETCH_ENGAGEMENT_SUMMARY,
}

export const reducer = Redux.combineReducers({
  data: Request.reducerChain([Sortable.stateReducer(reducerEvent)]),
  view: Request.reducerChain([summaryTypeReducer, filtersReducer, viewReducer(Sortable.viewReducer(reducerEvent))]),
})



// WEBPACK FOOTER //
// ./src/pages/engagement-summary/reducer.ts